import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAuth, updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';

function Navbar({ handleLogout, userInfo, tienePublicacionesNoVistas }) {
    const location = useLocation();
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [showChangePassword, setShowChangePassword] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth > 600) return; // Solo en móvil
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY && currentScrollY > 40) {
                setHidden(true); // Scroll hacia abajo
            } else {
                setHidden(false); // Scroll hacia arriba
            }
            setLastScrollY(currentScrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);





    const UserMenu = () => (
        <div style={{
            position: 'absolute',
            top: '100%',
            right: '10px',
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            padding: '8px 0',
            minWidth: '200px',
            zIndex: 1000
        }}>
            <div style={{
                padding: '12px 16px',
                borderBottom: '1px solid #eee'
            }}>
                <div style={{
                    fontSize: '0.85rem',
                    color: '#666',
                    marginBottom: '4px'
                }}>
                    Conectado como:
                </div>
                <div style={{
                    fontSize: '0.95rem',
                    color: '#1a3b5d',
                    fontWeight: '500'
                }}>
                    {userInfo?.email}
                </div>
            </div>
            <button
                onClick={() => setShowChangePassword(true)}
                style={{
                    width: '100%',
                    padding: '12px 16px',
                    textAlign: 'left',
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: '#1a3b5d',
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}
            >
                Cambiar contraseña
            </button>
            <button
                onClick={handleLogout}
                style={{
                    width: '100%',
                    padding: '12px 16px',
                    textAlign: 'left',
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: '#dc3545',
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}
            >
                <span style={{ fontSize: '1.1rem' }}>⇥</span>
                Cerrar Sesión
            </button>
        </div>
    );

    const menuItems = [
        { path: '/calendar', label: 'Calendario' },
        { path: '/pendientes', label: 'Publicaciones' },
        { path: '/mundial', label: 'Mundial' }
    ];

    const DrawerMenu = () => (
        <>
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1000,
                display: drawerOpen ? 'block' : 'none'
            }} onClick={() => setDrawerOpen(false)} />
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                bottom: 0,
                width: '280px',
                backgroundColor: 'white',
                boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
                zIndex: 1001,
                transform: drawerOpen ? 'translateX(0)' : 'translateX(-100%)',
                transition: 'transform 0.3s ease-in-out',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    padding: '20px',
                    borderBottom: '1px solid #eee',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/gnapps-logo.webp`}
                        alt="Logo"
                        style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'contain'
                        }}
                    />
                    <button
                        onClick={() => setDrawerOpen(false)}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#666'
                        }}
                    >
                        ×
                    </button>
                </div>
                <div style={{
                    padding: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                }}>
                    {menuItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            onClick={() => setDrawerOpen(false)}
                            style={{
                                padding: '12px 16px',
                                color: location.pathname === item.path ? '#1a3b5d' : '#6b7280',
                                textDecoration: 'none',
                                backgroundColor: location.pathname === item.path ? '#f0f2f5' : 'transparent',
                                borderRadius: '8px',
                                fontWeight: location.pathname === item.path ? '500' : 'normal',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                position: 'relative'
                            }}
                        >
                            {item.label}
                            {item.path === '/pendientes' && tienePublicacionesNoVistas && (
                                <span style={{
                                    position: 'absolute',
                                    top: '12px',
                                    right: '12px',
                                    width: '8px',
                                    height: '8px',
                                    backgroundColor: '#4299e1',
                                    borderRadius: '50%',
                                    display: 'inline-block'
                                }} />
                            )}
                        </Link>
                    ))}
                </div>
                <div style={{
                    marginTop: 'auto',
                    padding: '20px',
                    borderTop: '1px solid #eee'
                }}>
                    <div style={{
                        fontSize: '0.85rem',
                        color: '#666',
                        marginBottom: '4px'
                    }}>
                        Conectado como:
                    </div>
                    <div style={{
                        fontSize: '0.95rem',
                        color: '#1a3b5d',
                        fontWeight: '500',
                        marginBottom: '15px'
                    }}>
                        {userInfo?.email}
                    </div>
                    <button
                        onClick={() => setShowChangePassword(true)}
                        style={{
                            width: '100%',
                            padding: '12px 16px',
                            textAlign: 'left',
                            border: 'none',
                            backgroundColor: '#f0f2f5',
                            color: '#1a3b5d',
                            cursor: 'pointer',
                            fontSize: '0.95rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            borderRadius: '8px',
                            marginBottom: '8px'
                        }}
                    >
                        Cambiar contraseña
                    </button>
                    <button
                        onClick={handleLogout}
                        style={{
                            width: '100%',
                            padding: '12px 16px',
                            textAlign: 'left',
                            border: 'none',
                            backgroundColor: '#f0f2f5',
                            color: '#dc3545',
                            cursor: 'pointer',
                            fontSize: '0.95rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            borderRadius: '8px'
                        }}
                    >
                        <span style={{ fontSize: '1.1rem' }}>⇥</span>
                        Cerrar Sesión
                    </button>
                </div>
            </div>
        </>
    );

    const MobileBottomNav = () => (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'white',
            borderTop: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            padding: '10px 0',
            zIndex: 1000,
            boxShadow: '0 -2px 10px rgba(0,0,0,0.05)'
        }}>
            {menuItems.map((item) => (
                <Link key={item.path} to={item.path} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textDecoration: 'none',
                    color: location.pathname === item.path ? '#1a3b5d' : '#a0aec0',
                    gap: '4px',
                    position: 'relative',
                    paddingTop: '4px',
                    width: `${100 / menuItems.length}%`
                }}>
                    {location.pathname === item.path && (
                        <div style={{
                            position: 'absolute',
                            top: -10,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '80%',
                            height: '3px',
                            backgroundColor: '#1a3b5d',
                            borderBottomLeftRadius: '4px',
                            borderBottomRightRadius: '4px'
                        }} />
                    )}
                    {item.path === '/calendar' ? (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                    ) : item.path === '/mundial' ? (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="9"></circle>
                            <path d="M8.5 8.5l3.5-2 3.5 2 1 4-2.5 3h-4l-2.5-3 1-4z"></path>
                            <path d="M12 6V3M7.5 12.5 4.5 14M16.5 12.5l3 1.5M10 15.5 8.5 19M14 15.5l1.5 3.5"></path>
                        </svg>
                    ) : (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                    )}
                    <span style={{ fontSize: '0.75rem', fontWeight: 500 }}>{item.label}</span>
                    {item.path === '/pendientes' && tienePublicacionesNoVistas && (
                        <span style={{
                            position: 'absolute',
                            top: '2px',
                            right: '28%',
                            width: '8px',
                            height: '8px',
                            backgroundColor: '#4299e1',
                            borderRadius: '50%',
                            display: 'inline-block'
                        }} />
                    )}
                </Link>
            ))}
        </div>
    );
    return (
        <nav className={`navbar${hidden ? ' navbar-hidden' : ''}`} style={{
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            width: '100%'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                padding: isMobile ? '10px 20px' : '5px 30px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/gnapps-logo.webp`}
                        alt="Logo"
                        style={{
                            width: isMobile ? '50px' : '50px',
                            height: isMobile ? '50px' : '50px',
                            objectFit: 'contain'
                        }}
                    />
                </div>

                {isMobile ? (
                    <button
                        onClick={() => setDrawerOpen(true)}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: '10px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#1a3b5d'
                        }}
                    >
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </button>
                ) : (
                    <div style={{ position: 'relative' }}>
                        <button
                            onClick={() => setUserMenuOpen(!userMenuOpen)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '8px 20px',
                                border: 'none',
                                backgroundColor: '#f0f2f5',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#e4e6e9';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = '#f0f2f5';
                            }}
                        >
                            <span style={{
                                color: '#1a3b5d',
                                fontSize: '1.1rem',
                                fontWeight: '500'
                            }}>
                                {userInfo?.nombre || userInfo?.email}
                            </span>
                            <svg // ... keep svg logic
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#1a3b5d"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                        </button>
                        {userMenuOpen && <UserMenu />}
                    </div>
                )}
            </div>

            {!isMobile && (
                <div style={{
                    display: 'flex',
                    overflowX: 'auto',
                    padding: '0 30px',
                    borderTop: '1px solid #e5e7eb'
                }}>
                    {menuItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            style={{
                                padding: '10px 24px',
                                color: location.pathname === item.path ? '#1a3b5d' : '#6b7280',
                                textDecoration: 'none',
                                borderBottom: location.pathname === item.path ? '3px solid #1a3b5d' : '3px solid transparent',
                                fontWeight: location.pathname === item.path ? '600' : '500',
                                whiteSpace: 'nowrap',
                                position: 'relative',
                                fontSize: '1.05rem'
                            }}
                        >
                            {item.label}
                            {item.path === '/pendientes' && tienePublicacionesNoVistas && (
                                <span style={{
                                    position: 'absolute',
                                    top: '8px',
                                    right: '8px',
                                    width: '8px',
                                    height: '8px',
                                    backgroundColor: '#4299e1',
                                    borderRadius: '50%',
                                    display: 'inline-block'
                                }} />
                            )}
                        </Link>
                    ))}
                </div>
            )}

            {isMobile && <DrawerMenu />}
            {isMobile && <MobileBottomNav />}
            {showChangePassword && <ChangePasswordModal show={showChangePassword} onClose={() => setShowChangePassword(false)} />}
        </nav>
    );
}

// SVGs para el icono de ojo y ojo tachado
const EyeIcon = (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1a3b5d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path><circle cx="12" cy="12" r="3"></circle></svg>
);
const EyeOffIcon = (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1a3b5d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.81 21.81 0 0 1 5.06-6.06M1 1l22 22"></path><path d="M9.53 9.53A3 3 0 0 0 12 15a3 3 0 0 0 2.47-5.47"></path></svg>
);

const ChangePasswordModal = ({ show, onClose }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [passwordSuccess, setPasswordSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setPasswordError('');
        setPasswordSuccess('');
        if (!currentPassword) {
            setPasswordError('Por favor ingresa tu contraseña actual.');
            return;
        }
        if (!password1 || !password2) {
            setPasswordError('Por favor ingresa y confirma la nueva contraseña.');
            return;
        }
        if (password1 !== password2) {
            setPasswordError('Las contraseñas no coinciden.');
            return;
        }
        if (password1.length < 6) {
            setPasswordError('La contraseña debe tener al menos 6 caracteres.');
            return;
        }
        setLoading(true);
        try {
            const auth = getAuth();
            const user = auth.currentUser;
            if (!user) throw new Error('No hay usuario autenticado.');
            // Reautenticación
            const credential = EmailAuthProvider.credential(user.email, currentPassword);
            await reauthenticateWithCredential(user, credential);
            // Si reautenticación exitosa, cambiar contraseña
            await updatePassword(user, password1);
            setPasswordSuccess('¡Contraseña actualizada correctamente!');
            setCurrentPassword('');
            setPassword1('');
            setPassword2('');
        } catch (err) {
            if (err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
                setPasswordError('La contraseña actual que ingresaste es incorrecta. Por favor, verifica e inténtalo nuevamente.');
            } else if (err.code === 'auth/too-many-requests') {
                setPasswordError('Demasiados intentos fallidos. Intenta más tarde.');
            } else {
                setPasswordError('Ocurrió un error al cambiar la contraseña. Intenta nuevamente.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCurrentPasswordChange = (e) => setCurrentPassword(e.target.value);
    const handlePassword1Change = (e) => setPassword1(e.target.value);
    const handlePassword2Change = (e) => setPassword2(e.target.value);

    if (!show) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '12px',
                maxWidth: '400px',
                width: '90%',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
            }}>
                <h3 style={{ color: '#1a3b5d', marginTop: 0 }}>Cambiar contraseña</h3>
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div style={{ marginBottom: '15px', position: 'relative' }}>
                        <label style={{ display: 'block', marginBottom: '6px', color: '#1a3b5d' }}>Contraseña actual</label>
                        <input
                            type={showCurrentPassword ? 'text' : 'password'}
                            value={currentPassword}
                            onChange={handleCurrentPasswordChange}
                            style={{ width: '100%', padding: '8px 36px 8px 8px', borderRadius: '6px', border: '1px solid #ccc' }}
                            autoFocus
                        />
                        <button
                            type="button"
                            onClick={() => setShowCurrentPassword((v) => !v)}
                            tabIndex={-1}
                            style={{
                                position: 'absolute',
                                right: 8,
                                top: 34,
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 0
                            }}
                            aria-label={showCurrentPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            {showCurrentPassword ? EyeOffIcon : EyeIcon}
                        </button>
                    </div>
                    <div style={{ marginBottom: '15px', position: 'relative' }}>
                        <label style={{ display: 'block', marginBottom: '6px', color: '#1a3b5d' }}>Nueva contraseña</label>
                        <input
                            type={showPassword1 ? 'text' : 'password'}
                            value={password1}
                            onChange={handlePassword1Change}
                            style={{ width: '100%', padding: '8px 36px 8px 8px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword1((v) => !v)}
                            tabIndex={-1}
                            style={{
                                position: 'absolute',
                                right: 8,
                                top: 34,
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 0
                            }}
                            aria-label={showPassword1 ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            {showPassword1 ? EyeOffIcon : EyeIcon}
                        </button>
                    </div>
                    <div style={{ marginBottom: '15px', position: 'relative' }}>
                        <label style={{ display: 'block', marginBottom: '6px', color: '#1a3b5d' }}>Confirmar contraseña</label>
                        <input
                            type={showPassword2 ? 'text' : 'password'}
                            value={password2}
                            onChange={handlePassword2Change}
                            style={{ width: '100%', padding: '8px 36px 8px 8px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword2((v) => !v)}
                            tabIndex={-1}
                            style={{
                                position: 'absolute',
                                right: 8,
                                top: 34,
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 0
                            }}
                            aria-label={showPassword2 ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            {showPassword2 ? EyeOffIcon : EyeIcon}
                        </button>
                    </div>
                    {passwordError && <div style={{ color: '#dc3545', marginBottom: '10px' }}>{passwordError}</div>}
                    {passwordSuccess && <div style={{ color: '#28a745', marginBottom: '10px' }}>{passwordSuccess}</div>}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button
                            type="button"
                            onClick={() => {
                                onClose();
                                setCurrentPassword('');
                                setPassword1('');
                                setPassword2('');
                                setPasswordError('');
                                setPasswordSuccess('');
                            }}
                            style={{ padding: '8px 16px', border: '1px solid #ccc', borderRadius: '6px', backgroundColor: '#fff', cursor: 'pointer' }}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            style={{ padding: '8px 16px', backgroundColor: '#1a3b5d', color: 'white', border: 'none', borderRadius: '6px', cursor: loading ? 'not-allowed' : 'pointer' }}
                        >
                            {loading ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Navbar;
